import { render, staticRenderFns } from "./DataPrinter.vue?vue&type=template&id=0c0d3d72&scoped=true&"
import script from "./DataPrinter.vue?vue&type=script&lang=ts&"
export * from "./DataPrinter.vue?vue&type=script&lang=ts&"
import style0 from "./DataPrinter.vue?vue&type=style&index=0&id=0c0d3d72&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0d3d72",
  null
  
)

export default component.exports